import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import GLClosureCard from "./Card"

class GLClosureDetails extends React.Component {

  componentDidMount() {
    const { params, setCurrentId, loadData, glClosure } = this.props
    setCurrentId(params.id)
    if(!glClosure) {
      loadData()
    }
  }

  render() {
    const { glClosure } = this.props
    return glClosure ? <GLClosureCard glClosure={ glClosure } /> : <p>Loading ..</p>
  }
}

GLClosureDetails.propTypes = {
  glClosure: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const glClosure = DckSelectors.selectItemById(state, ItemTypes.GLClosure, ownProps.params.id)
  return { glClosure }
}

const mapDispatchToProps = dispatch => ({
  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.GLClosure, id)),
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLClosure)),
})

export default connect(mapStateToProps, mapDispatchToProps)(GLClosureDetails)



// WEBPACK FOOTER //
// ./src/components/Accounting/GLClosures/Details.js